import * as React from 'react';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '@/components/Ambassador/ReferralProvider';
import getLocal from '@/app/utils/getLocal';

const CallToActionBanner = () => {
    const { isMobile } = useGlobal();
    const { locale } = getLocal();
    const { actStatus } = useReferralStore();

    if (actStatus === 1) {
        return (
            <div className={styled.cta_banner}>
                <div className="refer_center">
                    <NextImage
                        src={
                            !isMobile
                                ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719218430443/na_cta_banner_pc.jpg'
                                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719213551765/na_dc_banner_m.jpg'
                        }
                        alt="EcoFlow Prime Day Sale"
                        aria-label="EcoFlow Prime Day Sale"
                    />
                    <div className="text_box">
                        <h3 className="title">EcoFlow Prime Day Sale</h3>
                        <p className="desc">{locale === 'ca' ? 'Up to $2,199 Off' : 'Up to $2,899 Off'}</p>
                        <p className="subtitle">Prime Power, Prime Savings July 1–21</p>
                        <button
                            className="cta-refer-btn"
                            onClick={() => {
                                location.href = `https://${locale}.ecoflow.com/pages/prime-day`;
                            }}
                        >
                            Shop Now
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return <></>;
};

export default CallToActionBanner;
